import { createAction, props } from '@ngrx/store';
import { CustomProductAttributeConfig, PriceConfig } from '../../types';
import {
  AvailableProduct,
  BasketStyles,
  CalendarInBasket,
  Cost,
  DeliveryMethods,
  MagnetInBasket,
  DisplayImagesStyles,
  FileInBasket,
  FilePrice,
  LookBookProductInBasket,
  PackageInBasket,
  PhotoGroupConfig,
  PhotoGroupHasPhoto,
  PriceToAddToEveryFileInLookbookProduct,
  PriceToAddToEveryFileInProduct,
  PriceToAddToFirstPrint,
  PrintPrice,
  ProductInBasket,
  PromoCodeInBasket,
  RetouchLevel,
  Settlements,
  TabloInBasket,
  VouchersPrints,
  ZalamoPrintConfig,
} from './standalone';
import { CustomLabel } from '../../../../types/Globalization';
import { ProductType } from '../../product-editor/graphql';
import {
  OrderContext,
  TabloForDisplay,
  WallDecorPieceCropInput,
} from '../../../../../../../public-session/src/graphql';

export const loadBasketStyle = createAction(
  '[Basket Style] load basket style',
  props<{
    basketStyle: BasketStyles;
  }>(),
);
export const addProductToBasketAction = createAction(
  '[Shopping cart] Add select product',
  props<{
    product: {
      nameClientProduct: string;
      productId: string;
      selectedProductId: string;
      quantity: number;
      firstAddedFile?: boolean;
      configuration: {
        [x: string]: string | boolean;
      };
      photoIdList: Array<{ photoId: string }>;
    };
  }>(),
);
export const addPhotoToProductInBasket = createAction(
  '[Shopping cart] Add photo to product in basket',
  props<{
    product: {
      selectedProductId: string;
      photoId: string;
    };
  }>(),
);
export const deletePhotoToProductInBasket = createAction(
  '[Shopping cart] Delete photo to product in basket',
  props<{
    product: {
      selectedProductId: string;
      photoId: string;
    };
  }>(),
);
export const changePhotoToProductInBasket = createAction(
  '[Shopping cart] Change photo to product in basket',
  props<{
    product: {
      selectedProductId: string;
      oldPhotoId: string;
      newPhotoId: string;
    };
  }>(),
);
export const changeProductInBasketAction = createAction(
  '[Shopping cart] Change product in basket',
  props<{
    changeInProduct: {
      nameClientProduct: string;
      selectedProductId: string;
      quantity: number;
      configuration: { [x: string]: string | boolean | number };
      firstAddedFile: boolean;
      photoIdList: Array<{ photoId: string }>;
    };
    productInBasket: ProductInBasket;
  }>(),
);
export const reconcileProductFilesInBasketAction = createAction(
  '[Shopping cart] Reconcile files granted with products',
);
export const deleteSelectedProductAction = createAction(
  '[Shopping cart] Delete product',
  props<{ selectedProductId: string }>(),
);
export const changeQuantitySelectedProductAction = createAction(
  '[Shopping cart] Change quantity product',
  props<{ selectedProductId: string; quantity: number }>(),
);
export const loadProductInShopAction = createAction(
  '[Shopping cart] Load product',
  props<{
    products: Array<{
      requiredImages: { max: number; min: number };
      imagesRequired: boolean;
      productId: string;
      name: string;
      description: Array<CustomLabel>;
      config: Array<CustomProductAttributeConfig>;
      type: ProductType;
      price: Array<PriceConfig>;
      showDeliveryTime: boolean;
      deliveryTime: number;
      free: number;
    }>;
  }>(),
);
export const loadProductVoucherAction = createAction(
  '[Shopping cart] Load product voucher',
  props<{
    voucher: Array<{
      percentDiscount: number;
      price: Array<PriceConfig>;
    }>;
  }>(),
);
export const loadCustomDigitalFileName = createAction(
  '[Shopping cart] Load custom digital FileName',
  props<{
    useCustomDigitalFileName: boolean;
    customDigitalFileName: Array<{
      language: string;
      text: string;
    }>;
  }>(),
);
export const loadMinimalOrderValueConfig = createAction(
  '[Shopping cart] loadMinimalOrderValueConfig',
  props<{
    enabled: boolean;
    value: PriceConfig[];
  }>(),
);
export const loadProductInBasketAction = createAction(
  '[Shopping cart] Updating prices of selected products',
  props<{
    product: Array<{
      nameClientProduct: string;
      selectedProductId: string;
      productId: string;
      quantity: number;
      configuration: { [x: string]: string | boolean };
      timeAddedToShoppingCart: number;
      photoIdList: Array<{ photoId: string }>;
      finished: { allImages: boolean; allOptions: boolean };
      redBackground: boolean;
      firstAddedFile: boolean;
    }>;
  }>(),
);
export const changeBackgroundColorAction = createAction(
  '[Shopping cart] change background color',
);

export const setShoppingCartIdAction = createAction(
  '[Shopping cart] set Id',
  props<{
    shoppingCartId: string;
  }>(),
);
export const verificationAllProductsInBasketAction = createAction(
  '[Shopping cart] verification all products in basket',
);
export const rebuildAllProductsInBasketAction = createAction(
  '[Shopping cart] rebuild all products in basket without verification',
);
export const setForcePhoneForDigitalOnlyAction = createAction(
  '[Shopping cart] set force phone for digital',
  props<{
    force: boolean;
  }>(),
);
export const changeDisplayImagesStyleInMobile = createAction(
  '[Images list] change display images styles',
  props<{
    mobile: DisplayImagesStyles;
  }>(),
);

export const restoreProductListAction = createAction(
  '[Product List] Restore Products',
  props<{
    products: Array<AvailableProduct>;
  }>(),
);
export const loadPhotoAction = createAction(
  '[Print and file] Load print photos',
  props<{
    photoGroupList: Array<{
      name: Array<{ language: string; text: string }>;
      photos: Array<{
        height: number;
        width: number;
        photoGroupHasPhotoId: string;
        photoId: string;
        photoGroupId: string;
      }>;
    }>;
  }>(),
);
export const loadPriceToAddToFirstPrintAction = createAction(
  '[Print] Load price to add to first print',
  props<{
    priceToAddToFirstPrint: PriceToAddToFirstPrint;
  }>(),
);
export const loadPrintPriceAction = createAction(
  '[Print] load print prices',
  props<{
    price: Array<PrintPrice>;
  }>(),
);

export const loadTabloPriceAction = createAction(
  '[Print] load tablo prices',
  props<{
    price: TabloForDisplay[];
  }>(),
);
export const loadDoNotAddPriceOfFirstPrintAction = createAction(
  '[Print] load do not add price of first print',
  props<{
    doNotAddPriceOfFirstPrint: boolean;
  }>(),
);
export const loadPrintVoucherAction = createAction(
  '[Print] load print vouchers',
  props<{
    voucher: Array<VouchersPrints>;
  }>(),
);
export const loadSkipFavoriteInFileMode = createAction(
  '[Print] load skip favorite in file mode',
  props<{
    skipFavoriteInFileMode: boolean;
  }>(),
);
export const addPrintToBasket = createAction(
  '[Print] add Prints For Photo',
  props<{
    prints: {
      photoId: string;
      printId: string;
      count: number;
      printFormatId: string;
      printPaperId: string;
      togetherWithFile?: boolean;
    };
  }>(),
);
export const addTabloToBasket = createAction(
  '[Tablo] add tablo to basket',
  props<{
    tablo: {
      tabloId: string;
      count: number;
    };
  }>(),
);
export const addCalendarToBasket = createAction(
  '[Calendar] add calendar to basket',
  props<{
    calendar: {
      thumb: string;
      crop: WallDecorPieceCropInput;
      photoId: string;
      photoGroupId: string;
      size: string;
      count: number;
    };
  }>(),
);
export const changePrintToBasket = createAction(
  '[Print] change Prints For Photo',
  props<{
    prints: {
      photoId: string;
      printId: string;
      count: number;
      printFormatId: string;
      printPaperId: string;
      togetherWithFile?: boolean;
    };
  }>(),
);

export const deletePrintAction = createAction(
  '[Print] delete Print',
  props<{
    printId: string;
  }>(),
);
export const deletePrintsAction = createAction(
  '[Print] delete Prints',
  props<{
    prints: Array<{
      printId: string;
    }>;
  }>(),
);
export const changePrintAction = createAction(
  '[Print] change Print',
  props<{
    printId: string;
    print: {
      printFormatId: string;
      printPaperId: string;
      photoId: number | string;
      count: number;
    };
  }>(),
);
export const changeQuantityPrintAction = createAction(
  '[Print] change quantity print',
  props<{
    photoId: string;
    printFormatId: string;
    printPaperId: string;
    quantity: number;
  }>(),
);
export const loadPrintsInBasketAction = createAction(
  '[Print] load prints',
  props<{
    prints: Array<{
      printFormatId: string;
      printPaperId: string;
      printId: string;
      photoId: string;
      count: number;
      togetherWithFile: boolean;
      timeAddedToShoppingCart: number;
    }>;
    frames: Array<{
      printFormatId: string;
      ratio: number;
      photoId: string;
      value: string;
      count: number;
      price: PriceConfig[];
      printFrameId: string;
    }>;
    notReset?: boolean;
  }>(),
);
export const loadFileVouchersAction = createAction(
  '[File] load file vouchers',
  props<{
    voucher: Array<{
      percentDiscount: number;
      price: Array<PriceConfig>;
    }>;
  }>(),
);
export const loadPhotoGroupAction = createAction(
  '[Print and file] load photo group',
  props<{
    photoGroup: Array<{
      photoGroupId: string;
      config: PhotoGroupConfig;
    }>;
  }>(),
);
export const loadSellConfigAction = createAction(
  '[Print and file] load sell config',
  props<{
    configSell: {
      sellFiles: boolean;
      sellPrints: boolean;
      sellProducts: boolean;
      sellPackages: boolean;
      excludedProducts: Array<string>;
      lookBookEnabled?: boolean;
      zalamoPrintConfig?: ZalamoPrintConfig;
    };
  }>(),
);
export const loadFileSizesAction = createAction(
  '[File] load file sises',
  props<{
    sizes: Array<{ size: number }>;
  }>(),
);
export const loadCurrency = createAction(
  '[Currency] load currency',
  props<{
    currency: string;
  }>(),
);
export const loadFilePricesAction = createAction(
  '[File] load file prices',
  props<{
    prices: Array<FilePrice>;
  }>(),
);
export const loadAddPriceToEveryFileInProduct = createAction(
  '[File] load add price to every file in product',
  props<{
    priceToAddToEveryFileInProduct: PriceToAddToEveryFileInProduct;
  }>(),
);
export const loadAddPriceToEveryFileInLookBookProduct = createAction(
  '[File] load add  price to every file in lookBookProduct',
  props<{
    priceToAddToEveryFileInLookBookProduct: PriceToAddToEveryFileInLookbookProduct;
  }>(),
);
export const setOwnPhotosPrintsPricing = createAction(
  '[OwnPhotos] set pricing',
  props<{
    pricing: Cost;
  }>(),
);
export const loadDeliveryMethodsAction = createAction(
  '[Delivery Methods] load delivery methods',
  props<{
    deliveryMethods: Array<DeliveryMethods>;
  }>(),
);
export const addDeliveryMethodChosenByClientAction = createAction(
  '[Delivery Methods] add delivery method chosen by client',
  props<{
    deliveryMethodId: string;
  }>(),
);
export const addFileInBasketAction = createAction(
  '[File] add file in basket',
  props<{
    file: {
      filePricingId: string;
      photoId: string;
      size: number;
      isFull: boolean;
      retouchLevelId: string;
      togetherWithProduct: boolean;
      togetherWithLookBookProduct?: boolean;
      togetherWithZalamoPrintProduct?: boolean;
      togetherWithPrint: boolean;
    };
  }>(),
);
export const addFilesInBasketAction = createAction(
  '[File] add files in basket',
  props<{
    files: Array<{
      filePricingId: string;
      photoId: string;
      size: number;
      isFull: boolean;
      retouchLevelId: string;
      togetherWithProduct: boolean;
      togetherWithLookBookProduct?: boolean;
      togetherWithZalamoPrintProduct?: boolean;
      togetherWithPrint: boolean;
    }>;
  }>(),
);
export const changeFileInBasketAction = createAction(
  '[File] change file in basket',
  props<{
    filePricingId: string;
    photoId: string;
    size?: number;
    isFull?: boolean;
    togetherWithProduct?: boolean;
    togetherWithLookBookProduct?: boolean;
    togetherWithZalamoPrintProduct?: boolean;
    togetherWithPrint?: boolean;
  }>(),
);
export const deleteFilesInBasketAction = createAction(
  '[File] delete files in basket',
  props<{
    files: Array<string>;
  }>(),
);
export const loadFilesInBasketAction = createAction(
  '[File] load files in basket',
  props<{
    file: Array<FileInBasket>;
    notReset?: boolean;
  }>(),
);
export const loadPromoCodeInBasketAction = createAction(
  '[File] load promo code',
  props<{
    promoCode: PromoCodeInBasket;
  }>(),
);
export const deleteFileInBasketAction = createAction(
  '[File] delete file in basket',
  props<{
    photoId: string;
  }>(),
);
export const loadPhotoGroupHasPhoto = createAction(
  '[Print and file] load photo group has photo data',
  props<{
    photoGroupHasPhotos: Array<PhotoGroupHasPhoto>;
  }>(),
);
export const loadLookBookProductsToBasketAction = createAction(
  '[LookBookProduct]  load lookBookProducts to basket',
  props<{
    lookBookProductsInBasket: Array<LookBookProductInBasket>;
  }>(),
);
export const loadTabloToBasketAction = createAction(
  '[Tablo]  load Tablo to basket',
  props<{
    tablo: Array<TabloInBasket>;
  }>(),
);
export const loadCalendarToBasketAction = createAction(
  '[Calendar]  load calendar to basket',
  props<{
    calendarInBasket: Array<CalendarInBasket>;
  }>(),
);
export const addMagnetToBasket = createAction(
  '[Magnet] add magnet to basket',
  props<{
    magnet: {
      thumb: string;
      crop: number[];
      photoId: string;
      photoGroupId: string;
      size: string;
      count: number;
    };
  }>(),
);
export const loadMagnetToBasketAction = createAction(
  '[Magnet]  load magnet to basket',
  props<{
    magnetInBasket: Array<MagnetInBasket>;
  }>(),
);
export const addLookBookProductToBasketAction = createAction(
  '[LookBookProduct] add lookBookProduct to basket',
  props<{
    lookBookProduct: Pick<
      LookBookProductInBasket,
      | 'lookBookProductConfigId'
      | 'countPhotos'
      | 'config'
      | 'thumb'
      | 'productsInPlay'
      | 'valueMap'
      | 'personalizationConfig'
      | 'hasPersonalization'
      | 'name'
      | 'nameClientProduct'
      | 'lookBookProductId'
      | 'quantity'
      | 'photoIdList'
      | 'finished'
      | 'redBackground'
      | 'firstAddedFile'
      | 'price'
      | 'accessToken'
      | 'imageMap'
    >;
  }>(),
);
export const changeQuantityLookBookProductInBasketAction = createAction(
  '[LookBookProduct]  change quantity lookBookProduct in basket',
  props<{
    lookBookProductConfigId: string;
    quantity: number;
  }>(),
);
export const changePhotosInLookBookProductInBasketAction = createAction(
  '[LookBookProduct]  change photos lookBookProduct in basket',
  props<{
    lookBookProductConfigId: string;
    addedPhotos: Array<string>;
    deletedPhotos: Array<string>;
  }>(),
);
export const changeConfigInLookBookProductInBasketAction = createAction(
  '[LookBookProduct]  change config lookBookProduct in basket',
  props<{
    product: Pick<
      LookBookProductInBasket,
      | 'lookBookProductConfigId'
      | 'config'
      | 'thumb'
      | 'valueMap'
      | 'accessToken'
      | 'price'
      | 'countPhotos'
      | 'redBackground'
      | 'finished'
      | 'photoIdList'
      | 'productsInPlay'
      | 'imageMap'
      | 'personalizationConfig'
      | 'hasPersonalization'
    >;
  }>(),
);
export const deleteLookBookProductFromBasketAction = createAction(
  '[LookBookProduct]  delete lookBookProduct from basket',
  props<{
    lookBookProductConfigId: string;
  }>(),
);
export const loadFreePackageAction = createAction(
  '[Print and file] load free package',
  props<{
    freePackageId: string;
    wasAlreadyOrdered: boolean;
  }>(),
);
export const loadRetouchLevelsAction = createAction(
  '[File] load retouch levels',
  props<{
    retouchLevels: Array<RetouchLevel>;
  }>(),
);
export const changeRetouchInFileAction = createAction(
  '[File] change retouch in file',
  props<{
    photoId: string;
    retouchLevelId: string;
  }>(),
);
export const changeManyRetouchInFilesAction = createAction(
  '[File] change many retouch in files',
  props<{
    manyRetouch: Array<{
      photoId: string;
      retouchLevelId: string;
    }>;
  }>(),
);
export const loadUsePromoCodesAction = createAction(
  '[Codes] load use promo codes',
  props<{
    usePromoCodes: boolean;
  }>(),
);
export const loadSettlementsAction = createAction(
  '[Settlements] load settlements',
  props<{
    settlements: Settlements;
  }>(),
);
export const loadPackageAction = createAction(
  '[Packet] load package',
  props<{
    packages: {
      package: Array<{
        name: string;
        icon: string;
        allowMultiple: boolean;
        productPackageId: string;
        productConfig: Array<{
          config?: string;
          productId?: string;
          productInPackageId?: string;
          qty?: number;
          icon?: string;
          mode?: string;
          customName?: Array<{
            language: string;
            text: string;
          }>;
        }>;
        printAndFileConfig: Array<{
          printAndFileConfigId?: string;
          mode?: string;
          groups?: Array<string>;
          addFileToPrintInPackage?: boolean;
          forcedImage?: { photoGroupId: string; photoId: string };
          printsCount: Array<{
            count?: number;
            printPaperId?: string;
            printFormatId?: string;
          }>;
          filesConfig: Array<{
            count?: number;
            size?: number;
            isFull?: boolean;
          }>;
        }>;
        price: Array<PriceConfig>;
      }>;
      onePackage: boolean;
    };
  }>(),
);
export const loadPackagesInBasketAction = createAction(
  '[Packet] load package in basket',
  props<{
    packages: Array<PackageInBasket>;
  }>(),
);
export const loadDealerMandatoryPackageAtTheBeginningAction = createAction(
  '[Packet] loading dealer "yes / no" adding package',
  props<{
    mandatoryPackageAtTheBeginningAction: boolean;
  }>(),
);
export const loadBayerMandatoryPackageAtTheBeginningAction = createAction(
  '[Packet] loading bayer "yes / no" adding package',
  props<{
    mandatoryPackageAtTheBeginningAction: boolean;
  }>(),
);
export const addBayerMandatoryPackageAtTheBeginningAction = createAction(
  '[Packet] add bayer "yes / no" adding package',
  props<{
    mandatoryPackageAtTheBeginningAction: boolean;
  }>(),
);
export const loadFavListAction = createAction(
  '[Photo] load favorite images list',
  props<{
    favList: { all: Array<string>; current: Array<string> };
  }>(),
);
export const loadMenuOfLovedPhotosAction = createAction(
  '[Photo] load menu Of Loved Photos "yes / no"',
  props<{
    menuOfLovedPhotos: boolean;
  }>(),
);
export const changeFavListAction = createAction(
  '[Fav] change favorite images list',
  props<{
    favList: { all: Array<string>; current: Array<string> };
  }>(),
);
export const addImageToFavListAction = createAction(
  '[Fav] add image to favList',
  props<{
    photoId: string;
  }>(),
);
export const deleteImageFromFavListAction = createAction(
  '[Fav] delete image from favList',
  props<{
    photoId: string;
  }>(),
);
export const changeImageListAction = createAction(
  '[Fav] change list of displayed photos to favorites',
  props<{
    onyFavImages: boolean;
  }>(),
);
export const addPackageToBasketAction = createAction(
  '[Packet] add package to basket',
  props<{
    package: {
      packageId: string;
      count: number;
    };
  }>(),
);
export const addProductInPackageToBasketAction = createAction(
  '[Packet] add product in package to basket',
  props<{
    packageInBasketId: string;
    product: {
      photos: Array<{ photoId: string }>;
      count: number;
      nameClientProduct?: string;
      productId: string;
      productInPackageId: string;
      config: { [x: string]: string | boolean };
      selectedProductId?: string;
      photosAddedByCustomer: boolean;
    };
  }>(),
);
export const addPrintInPackageToBasketAction = createAction(
  '[Packet] add print in package to basket',
  props<{
    packageInBasketId: string;
    print: {
      printPaperId: string;
      printFormatId: string;
      photoId: string;
      count: number;
      printAndFileConfigId: string;
    };
  }>(),
);
export const addFileInPackageToBasketAction = createAction(
  '[Packet] add file in package to basket',
  props<{
    packageInBasketId: string;
    file: {
      size: number;
      isFull: boolean;
      photoId: string;
      printAndFileConfigId?: string;
      togetherWithPrint?: boolean;
    };
  }>(),
);
export const addOneImageInPackageToBasketAction = createAction(
  '[Packet] add one image in package to basket',
  props<{
    package: {
      print: Array<{
        photoId: string;
        printPaperId: string;
        printFormatId: string;
        count: number;
        printAndFileConfigId: string;
      }>;
      file: Array<{
        photoId: string;
        size: number;
        isFull: boolean;
        printAndFileConfigId: string;
      }>;
      packageInBasketId: string;
      printAndFileConfigId: string;
    };
  }>(),
);
export const changeProductInPackageInBasketAction = createAction(
  '[Packet] change quality product in package in basket',
  props<{
    product: {
      count: number;
      selectedProductId: string;
    };
    packageInBasketId: string;
  }>(),
);
export const deleteFilesAndPrintsInPackageInBasketAction = createAction(
  '[Packet] delete file and prints in package in basket',
  props<{
    photoId: string;
    packageInBasketId: string;
    printAndFileConfigId: string;
    print: Array<{
      photoId: string;
      printPaperId: string;
      printFormatId: string;
      count: number;
      printAndFileConfigId: string;
    }>;
    file: Array<{
      photoId: string;
      size: number;
      isFull: boolean;
      printAndFileConfigId: string;
    }>;
  }>(),
);
export const loadDateAction = createAction('load date');
export const resetDateAction = createAction(
  'reset date',
  props<{
    lightReset: boolean;
  }>(),
);
export const deleteFileInPackageInBasketAction = createAction(
  '[Packet] delete file in package in basket',
  props<{
    photoId: string;
    packageInBasketId: string;
  }>(),
);
export const changeWasProposedPackageWithPhotosAction = createAction(
  '[Packet] change was proposed package with photos',
);
export const deletePrintInPackageInBasketAction = createAction(
  '[Packet] delete print in package in basket',
  props<{
    photoId: string;
    printPaperId: string;
    printFormatId: string;
    printAndFileConfigId: string;
    packageInBasketId: string;
  }>(),
);
export const deleteProductInPackageInBasketAction = createAction(
  '[Packet] delete product in package in basket',
  props<{
    selectedProductId: string;
    packageInBasketId: string;
  }>(),
);
export const deletePackageInBasketAction = createAction(
  '[Packet] delete package in basket',
  props<{
    packageInBasketId: string;
  }>(),
);
export const changeQuantityPackageInBasketAction = createAction(
  '[Packet] change quantity package in basket',
  props<{
    packageInBasketId: string;
    quantity: number;
  }>(),
);
export const addPrintsListToBasketAction = createAction(
  '[Packet] add prints list to basket',
  props<{
    prints: Array<{
      photoId: string;
      printId: string;
      count: number;
      printFormatId: string;
      printPaperId: string;
      togetherWithFile?: boolean;
    }>;
  }>(),
);
export const setShoppingCartContext = createAction(
  '[setShoppingContext]',
  props<{
    context: {
      context: OrderContext;
      contextId: string;
    };
  }>(),
);
export const setOrderNumber = createAction(
  '[shoppingCart] setOrderNumber',
  props<{
    orderNumber: number;
    hash: string;
    orderAuthToken: string;
  }>(),
);
export const setSearchPhrase = createAction(
  '[shoppingCart] setSearchPhrase',
  props<{
    searchPhrase: string;
  }>(),
);
export const setPromoCode = createAction(
  '[shoppingCart] Set Promo Code',
  props<{
    promoCode: PromoCodeInBasket;
  }>(),
);

export const addPrintFrameAction = createAction(
  '[shoppingCartFrames] add PrintFrame',
  props<{
    printFrame: {
      photoId: string;
      ratio: number;
      printFormatId: string;
      value: string;
      price: PriceConfig[];
      printFrameId: string;
    };
  }>(),
);
export const changePrintFrameCountAction = createAction(
  '[shoppingCartFrames] change count PrintFrame',
  props<{
    photoId: string;
    printFrameId: string;
    count: number;
  }>(),
);
export const deletePrintFrameAction = createAction(
  '[shoppingCartFrames] delete count PrintFrame',
  props<{
    printFrameId: string;
    photoId: string;
  }>(),
);
